module.exports = __webpack_public_path__ + "img/coin-bi.48e17004.png";